export type WorkType = "movie" | "tvseries";

export interface Work {
  id: string;
  title: string;
  originalTitle: string;
  type: WorkType;
  year: number;
  genres: string[];
  rating: number;
  popularity: number;
  duration: string;
  director: string;
  cast: string[];
  updateDate: string;
  synopsis: string;
  poster: string;
  backdrop: string;
  featured: boolean;
}

export const GENRE_OPTIONS: string[] = [
  "伦理情感",
  "伦理悬疑",
  "家庭伦理",
  "都市伦理",
  "爱情伦理",
  "复仇伦理",
];

export const YEAR_OPTIONS: { label: string; value: string }[] = [
  { label: "近五年", value: "5" },
  { label: "十年内", value: "10" },
  { label: "全部", value: "all" },
];

export const SORT_OPTIONS: { label: string; value: string }[] = [
  { label: "按热度", value: "popularity" },
  { label: "按最新", value: "latest" },
  { label: "按评分", value: "rating" },
];

export const works: Work[] = [
  {
    id: "m01",
    title: "首尔夜雨",
    originalTitle: "Seoul Night Rain",
    type: "movie",
    year: 2023,
    genres: ["伦理情感", "爱情伦理"],
    rating: 8.4,
    popularity: 9820,
    duration: "118分钟",
    director: "朴成勋",
    cast: ["金敏书", "李东旭", "车秀妍", "尹在浩"],
    updateDate: "2023-11-02",
    synopsis:
      "一场持续整夜的雨，让两位在同一屋檐下渐行渐远的夫妻重新面对彼此。她翻出旧日记，他带来一纸未曾开口的道歉，都市霓虹下的情感裂缝被雨水悄然照亮。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20silhouette%20of%20a%20couple%20standing%20apart%20in%20rainy%20night%20street%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20moody%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20editorial%20cinematic%20photography&width=500&height=750&seq=krfilm-p01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20scene%20of%20rainy%20Seoul%20city%20street%20at%20night%2C%20reflective%20wet%20asphalt%20and%20soft%20neon%20glow%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20highlights%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20film%20still%2C%20grainy%20texture%2C%20no%20text&width=1600&height=900&seq=krfilm-b01&orientation=landscape",
    featured: true,
  },
  {
    id: "m02",
    title: "母亲的秘密",
    originalTitle: "Mother's Secret",
    type: "movie",
    year: 2022,
    genres: ["家庭伦理", "伦理悬疑"],
    rating: 8.1,
    popularity: 8710,
    duration: "106分钟",
    director: "郑有美",
    cast: ["高银珠", "朴海日", "李圣经"],
    updateDate: "2022-09-18",
    synopsis:
      "整理遗物的女儿在旧木箱底层发现一叠从未寄出的信件，揭开了母亲隐藏半生的往事。两个时代的女性命运在同一间老屋里交叠，家庭伦理的柔软与沉重一并浮现。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20elderly%20woman%20looking%20through%20a%20dusty%20attic%20window%2C%20muted%20sepia%20and%20deep%20navy%20tones%2C%20soft%20window%20light%2C%20film%20grain%20texture%2C%20melancholic%20mood%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20editorial%20cinematic%20photography&width=500&height=750&seq=krfilm-p02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20dim%20old%20Korean%20family%20house%20interior%20with%20wooden%20floor%20and%20paper%20lantern%2C%20soft%20dusty%20light%20through%20window%2C%20muted%20sepia%20and%20navy%20color%20palette%2C%20nostalgic%20quiet%20mood%2C%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-b02&orientation=landscape",
    featured: true,
  },
  {
    id: "m03",
    title: "沉默的继父",
    originalTitle: "The Silent Stepfather",
    type: "movie",
    year: 2024,
    genres: ["家庭伦理", "伦理悬疑"],
    rating: 7.8,
    popularity: 7950,
    duration: "124分钟",
    director: "崔振浩",
    cast: ["宋康昊铉", "金泰璃", "罗美兰英"],
    updateDate: "2024-06-21",
    synopsis:
      "一个沉默寡言的男人走进母子二人的生活，善意与戒备在同一张餐桌上对峙。当旧案的阴影再次浮现，他必须用行动证明自己的清白，也要面对自己掩藏的过去。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20back%20silhouette%20of%20a%20tall%20man%20standing%20in%20a%20dim%20doorway%2C%20cool%20steel%20blue%20grading%20with%20a%20single%20amber%20lamp%2C%20tense%20atmospheric%20lighting%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dim%20quiet%20suburban%20Korean%20neighborhood%20at%20dusk%2C%20narrow%20alley%20with%20warm%20lamp%20glow%20and%20long%20shadows%2C%20cool%20steel%20blue%20tones%2C%20mysterious%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b03&orientation=landscape",
    featured: false,
  },
  {
    id: "m04",
    title: "汉江之畔",
    originalTitle: "By the Han River",
    type: "movie",
    year: 2021,
    genres: ["爱情伦理", "都市伦理"],
    rating: 7.6,
    popularity: 6880,
    duration: "112分钟",
    director: "韩智敏",
    cast: ["李帝勋", "金高银珠", "吴政世"],
    updateDate: "2021-04-30",
    synopsis:
      "两名在汉江边夜跑时相遇的陌生人，各自怀揣着一段失败的感情。他们在无数个清晨与黄昏里交换心事，也在城市节奏中学会原谅与重新开始。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20two%20distant%20figures%20jogging%20along%20a%20river%20at%20sunset%2C%20warm%20orange%20and%20soft%20blue%20grading%2C%20dreamy%20backlight%20and%20lens%20flare%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Beautiful%20Han%20River%20waterfront%20at%20golden%20hour%2C%20city%20skyline%20reflection%20on%20calm%20water%2C%20warm%20orange%20and%20soft%20blue%20grading%2C%20romantic%20cinematic%20film%20still%2C%20gentle%20haze%2C%20no%20text&width=1600&height=900&seq=krfilm-b04&orientation=landscape",
    featured: false,
  },
  {
    id: "m05",
    title: "双面妻子",
    originalTitle: "The Two-Faced Wife",
    type: "movie",
    year: 2024,
    genres: ["伦理悬疑", "都市伦理"],
    rating: 8.0,
    popularity: 9130,
    duration: "120分钟",
    director: "姜素拉",
    cast: ["徐睿知", "金英光", "李世荣"],
    updateDate: "2024-08-14",
    synopsis:
      "丈夫眼中的完美妻子，在同事眼中却是另一个人。一桩匿名举报让平静的婚姻浮出水面，真相一层层揭开，每个人都藏着不愿被看见的一面。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20split%20portrait%20of%20a%20woman%20half%20lit%20half%20in%20shadow%2C%20cold%20navy%20blue%20and%20warm%20amber%20contrast%2C%20tense%20mystery%20lighting%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20modern%20Seoul%20luxury%20apartment%20interior%20at%20night%2C%20reflections%20on%20glass%20and%20cool%20navy%20blue%20lighting%2C%20single%20warm%20lamp%2C%20suspenseful%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b05&orientation=landscape",
    featured: true,
  },
  {
    id: "m06",
    title: "逆流而上的她",
    originalTitle: "Her Upstream",
    type: "movie",
    year: 2023,
    genres: ["都市伦理", "复仇伦理"],
    rating: 7.9,
    popularity: 8420,
    duration: "115分钟",
    director: "尹恩惠",
    cast: ["全汝彬", "朴正民", "韩孝周琳"],
    updateDate: "2023-07-09",
    synopsis:
      "被公司抛弃的单亲母亲，用一份被所有人低估的方案重回谈判桌。她要的不是复仇的快感，而是一个能让自己与孩子体面生活的答案。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20determined%20woman%20silhouette%20walking%20against%20a%20stream%20of%20city%20light%2C%20deep%20navy%20blue%20with%20strong%20warm%20orange%20accent%2C%20dramatic%20side%20lighting%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20Seoul%20corporate%20office%20tower%20at%20night%20seen%20from%20below%2C%20glass%20facade%20with%20cool%20navy%20blue%20and%20warm%20orange%20city%20lights%2C%20ambitious%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b06&orientation=landscape",
    featured: false,
  },
  {
    id: "m07",
    title: "旧宅疑云",
    originalTitle: "The Old House",
    type: "movie",
    year: 2022,
    genres: ["伦理悬疑", "家庭伦理"],
    rating: 7.5,
    popularity: 6210,
    duration: "109分钟",
    director: "白承勋",
    cast: ["金瑞亨", "李胜基", "柳真雅"],
    updateDate: "2022-12-03",
    synopsis:
      "为继承遗产回到祖宅的三兄妹，在阁楼里发现一本记满名字的旧账。尘封的家事与乡里的流言交织，血缘之下的裂痕比老屋的墙缝更深。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20old%20wooden%20house%20at%20night%20with%20flickering%20window%20light%2C%20cold%20navy%20blue%20tones%20and%20amber%20glow%2C%20haunting%20atmospheric%20lighting%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Abandoned%20traditional%20Korean%20hanok%20house%20at%20twilight%2C%20overgrown%20garden%20and%20fog%2C%20cold%20navy%20blue%20tones%20with%20faint%20amber%20window%20light%2C%20mysterious%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b07&orientation=landscape",
    featured: false,
  },
  {
    id: "m08",
    title: "未寄出的信",
    originalTitle: "The Unsent Letter",
    type: "movie",
    year: 2021,
    genres: ["伦理情感", "家庭伦理"],
    rating: 8.2,
    popularity: 7240,
    duration: "103分钟",
    director: "申敏儿",
    cast: ["孔晓振", "郑敬淏", "金香起"],
    updateDate: "2021-10-25",
    synopsis:
      "邮局职员多年替人保管一封无人认领的信，直到收件人出现。信件牵出一段错过的亲情，也让她重新审视自己与父亲之间那道沉默的墙。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20hands%20holding%20an%20old%20letter%20in%20soft%20light%2C%20warm%20amber%20and%20gentle%20blue%20grading%2C%20intimate%20tender%20mood%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20small%20Korean%20post%20office%20interior%20in%20afternoon%20light%2C%20mailboxes%20and%20paper%20textures%2C%20warm%20amber%20and%20soft%20blue%20grading%2C%20nostalgic%20gentle%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b08&orientation=landscape",
    featured: false,
  },
  {
    id: "m09",
    title: "出租屋里的夏天",
    originalTitle: "Summer in the Rental",
    type: "movie",
    year: 2023,
    genres: ["都市伦理", "爱情伦理"],
    rating: 7.4,
    popularity: 5920,
    duration: "98分钟",
    director: "林尚宇",
    cast: ["崔宇植", "金多美", "朴恩斌"],
    updateDate: "2023-08-11",
    synopsis:
      "两个为了生活合租的年轻人，在一个闷热的夏天里共享冰箱、天台和心事。房租到期的那天，他们才发现最难说出口的不是喜欢，而是留下。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20two%20young%20figures%20on%20a%20rooftop%20at%20warm%20summer%20dusk%2C%20soft%20orange%20and%20muted%20blue%20grading%2C%20bittersweet%20candid%20mood%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunlit%20small%20Korean%20rooftop%20apartment%20in%20summer%2C%20laundry%20lines%20and%20city%20view%2C%20warm%20orange%20and%20soft%20blue%20grading%2C%20youthful%20nostalgic%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b09&orientation=landscape",
    featured: false,
  },
  {
    id: "m10",
    title: "断线的风筝",
    originalTitle: "Broken Kite",
    type: "movie",
    year: 2020,
    genres: ["家庭伦理", "伦理情感"],
    rating: 7.7,
    popularity: 5660,
    duration: "111分钟",
    director: "赵成贤",
    cast: ["薛耿求", "千禹熙", "李到晛"],
    updateDate: "2020-05-19",
    synopsis:
      "父亲用一生修补一只断线的风筝，儿子却只想离开小镇。多年后归来，他才读懂父亲沉默背后的牵挂，也终于学会了放手。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20lone%20kite%20in%20a%20vast%20moody%20sky%20above%20a%20small%20town%2C%20muted%20blue%20and%20warm%20amber%20grading%2C%20wistful%20melancholic%20mood%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20rural%20Korean%20town%20at%20dusk%20with%20open%20fields%20and%20distant%20hills%2C%20muted%20blue%20and%20warm%20amber%20grading%2C%20wistful%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b10&orientation=landscape",
    featured: false,
  },
  {
    id: "m11",
    title: "第三个夜晚",
    originalTitle: "The Third Night",
    type: "movie",
    year: 2024,
    genres: ["伦理悬疑", "伦理情感"],
    rating: 8.3,
    popularity: 9060,
    duration: "126分钟",
    director: "李在勋",
    cast: ["朴恩彬", "宋江", "金智秀允"],
    updateDate: "2024-09-27",
    synopsis:
      "连续三个夜晚，同一间旅馆房间住进三对不同的男女。看似无关的三段关系，在第三夜揭开了彼此交错的秘密，也逼问每个人关于忠诚的底线。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20corridor%20of%20a%20dim%20hotel%20with%20three%20numbered%20doors%2C%20cool%20navy%20blue%20and%20warm%20amber%20glow%2C%20suspenseful%20elegant%20lighting%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Elegant%20dim%20hotel%20corridor%20at%20night%20with%20soft%20amber%20lamps%20and%20cool%20navy%20blue%20shadows%2C%20mysterious%20refined%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b11&orientation=landscape",
    featured: false,
  },
  {
    id: "s01",
    title: "首尔屋檐下",
    originalTitle: "Under the Seoul Rooftop",
    type: "tvseries",
    year: 2024,
    genres: ["家庭伦理", "都市伦理"],
    rating: 8.5,
    popularity: 9940,
    duration: "16集",
    director: "金泰宇",
    cast: ["罗美兰", "金海淑", "李熙俊", "郑恩地"],
    updateDate: "2024-10-08",
    synopsis:
      "一栋老式公寓里住着三代同堂的大家庭，屋檐下的每一扇门后都藏着难以言说的家事。邻里之间的守望与算计，交织成一幅真实又温情的都市家庭群像。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20Korean%20old%20apartment%20building%20with%20warm%20lit%20windows%20at%20dusk%2C%20deep%20navy%20blue%20sky%20with%20amber%20glow%2C%20lived-in%20heartwarming%20mood%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Charming%20old%20Korean%20apartment%20alley%20at%20dusk%20with%20warm%20window%20lights%20and%20hanging%20plants%2C%20deep%20navy%20blue%20and%20amber%20grading%2C%20warm%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b12&orientation=landscape",
    featured: true,
  },
  {
    id: "s02",
    title: "欲望的边界",
    originalTitle: "Edge of Desire",
    type: "tvseries",
    year: 2023,
    genres: ["伦理情感", "伦理悬疑"],
    rating: 8.2,
    popularity: 9370,
    duration: "20集",
    director: "朴赞浩",
    cast: ["孙艺珍娜", "李政宰", "金泰梨", "南柱赫"],
    updateDate: "2023-12-15",
    synopsis:
      "四位身处上流社会的男女，在体面生活与隐秘欲望之间反复试探。当一条匿名短信打破平衡，每个人都必须在欲望的边界上做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20elegant%20couple%20silhouette%20against%20a%20rain%20streaked%20glass%20wall%2C%20deep%20navy%20blue%20with%20rich%20amber%20accents%2C%20sensual%20restrained%20lighting%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Luxurious%20modern%20Seoul%20penthouse%20at%20night%20with%20city%20lights%20through%20glass%20walls%2C%20deep%20navy%20blue%20and%20warm%20amber%20grading%2C%20glamorous%20tense%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b13&orientation=landscape",
    featured: true,
  },
  {
    id: "s03",
    title: "双城秘密",
    originalTitle: "Secrets of Two Cities",
    type: "tvseries",
    year: 2024,
    genres: ["伦理悬疑", "都市伦理"],
    rating: 7.9,
    popularity: 8330,
    duration: "12集",
    director: "崔东勋",
    cast: ["金南佶", "申铉彬", "李絮"],
    updateDate: "2024-07-04",
    synopsis:
      "一名记者在首尔与釜山之间往返调查一桩旧案，两个城市、两段人生，因同一份档案被悄悄连在一起。越接近真相，她越发现秘密就在自己家里。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20figure%20walking%20between%20two%20distant%20city%20skyline%20silhouettes%2C%20cool%20navy%20blue%20and%20warm%20amber%20grading%2C%20investigative%20tense%20mood%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Split%20view%20of%20two%20Korean%20city%20skylines%20at%20night%20with%20misty%20harbor%2C%20cool%20navy%20blue%20and%20warm%20amber%20lights%2C%20mysterious%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-b14&orientation=landscape",
    featured: false,
  },
  {
    id: "s04",
    title: "婚姻的裂缝",
    originalTitle: "Cracks in Marriage",
    type: "tvseries",
    year: 2022,
    genres: ["家庭伦理", "都市伦理"],
    rating: 8.0,
    popularity: 8760,
    duration: "24集",
    director: "李相允",
    cast: ["金喜爱", "池晟", "韩佳人", "金武烈"],
    updateDate: "2022-11-20",
    synopsis:
      "结婚十五年的夫妻在平淡日子里渐行渐远，一次意外让裂缝彻底显现。孩子在中间沉默，长辈在旁劝和，一个家庭如何在裂缝中重新选择彼此。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20a%20cracked%20porcelain%20plate%20on%20a%20dining%20table%20in%20soft%20light%2C%20muted%20blue%20and%20warm%20amber%20grading%2C%20quiet%20melancholic%20mood%2C%20film%20grain%20texture%2C%20minimal%20elegant%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20modern%20Korean%20dining%20room%20in%20soft%20evening%20light%2C%20empty%20chairs%20and%20warm%20lamp%2C%20muted%20blue%20and%20amber%20grading%2C%20restrained%20emotional%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b15&orientation=landscape",
    featured: false,
  },
  {
    id: "s05",
    title: "她们的抉择",
    originalTitle: "Their Choices",
    type: "tvseries",
    year: 2023,
    genres: ["都市伦理", "伦理情感"],
    rating: 8.1,
    popularity: 8890,
    duration: "18集",
    director: "郑智宇",
    cast: ["河智苑", "金泰希", "朴宝英", "柳俊烈"],
    updateDate: "2023-09-12",
    synopsis:
      "三位职场女性在同一天做出改变人生的决定：辞职、结婚、远行。十年后她们再次相聚，才明白当初每一个抉择，都指向了今天各自的答案。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20three%20distinct%20woman%20silhouettes%20standing%20under%20city%20light%2C%20deep%20navy%20blue%20with%20warm%20orange%20highlights%2C%20empowering%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20Seoul%20streetscape%20at%20blue%20hour%20with%20glass%20office%20towers%20and%20warm%20headlights%2C%20deep%20navy%20blue%20and%20orange%20grading%2C%20uplifting%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b16&orientation=landscape",
    featured: false,
  },
  {
    id: "s06",
    title: "归来的人",
    originalTitle: "The Returned",
    type: "tvseries",
    year: 2024,
    genres: ["伦理悬疑", "复仇伦理"],
    rating: 7.8,
    popularity: 8120,
    duration: "14集",
    director: "张允浩",
    cast: ["李准基", "文彩元", "金赛纶"],
    updateDate: "2024-05-30",
    synopsis:
      "失踪七年的男人突然回到故乡，却发现家里的一切早已重新开始。他试图找回属于自己的位置，也一步步逼近当年离开的真相。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20lone%20man%20figure%20seen%20from%20behind%20on%20an%20empty%20country%20road%2C%20cold%20navy%20blue%20and%20faint%20amber%20horizon%2C%20mysterious%20lonely%20lighting%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20foggy%20country%20road%20at%20dawn%20with%20distant%20hills%20and%20a%20single%20car%20light%2C%20cold%20navy%20blue%20and%20faint%20amber%20grading%2C%20suspenseful%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b17&orientation=landscape",
    featured: false,
  },
  {
    id: "s07",
    title: "母亲的账本",
    originalTitle: "Mother's Ledger",
    type: "tvseries",
    year: 2021,
    genres: ["家庭伦理", "伦理情感"],
    rating: 8.3,
    popularity: 7990,
    duration: "30集",
    director: "高贤贞",
    cast: ["金惠子", "罗文姬", "李顺载", "朴智厚"],
    updateDate: "2021-06-16",
    synopsis:
      "一位母亲用一本旧账本记下几十年来为家人付出的每一笔。当账本被儿女们发现，数字背后的是一个家庭最真实的温度与亏欠。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20old%20ledger%20notebook%20and%20reading%20glasses%20on%20a%20wooden%20table%2C%20warm%20sepia%20and%20deep%20navy%20grading%2C%20tender%20nostalgic%20lighting%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20traditional%20Korean%20kitchen%20interior%20with%20ceramic%20jars%20and%20soft%20daylight%2C%20sepia%20and%20navy%20grading%2C%20comforting%20family%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b18&orientation=landscape",
    featured: false,
  },
  {
    id: "s08",
    title: "深夜咖啡屋",
    originalTitle: "Late Night Cafe",
    type: "tvseries",
    year: 2022,
    genres: ["都市伦理", "伦理情感"],
    rating: 7.6,
    popularity: 6640,
    duration: "16集",
    director: "吴忠焕",
    cast: ["姜河那", "孔升妍", "金宇彬"],
    updateDate: "2022-03-08",
    synopsis:
      "一家只在深夜营业的咖啡屋，接待着形形色色的客人。每一杯饮品背后，都是都市人无处安放的心事，而店主自己也在等待一个不会回来的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20cozy%20little%20cafe%20window%20glowing%20warm%20at%20night%20on%20a%20quiet%20street%2C%20deep%20navy%20blue%20with%20warm%20amber%20glow%2C%20intimate%20cinematic%20mood%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Charming%20small%20cafe%20interior%20at%20night%20with%20warm%20hanging%20lamps%20and%20wooden%20counters%2C%20deep%20navy%20blue%20and%20amber%20grading%2C%20cozy%20intimate%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b19&orientation=landscape",
    featured: false,
  },
  {
    id: "s09",
    title: "夜色中的信",
    originalTitle: "Letters in the Night",
    type: "tvseries",
    year: 2023,
    genres: ["伦理情感", "伦理悬疑"],
    rating: 7.7,
    popularity: 7010,
    duration: "16集",
    director: "金成允",
    cast: ["朴叙俊", "金所泫", "李到晛熙"],
    updateDate: "2023-05-22",
    synopsis:
      "一位夜班电台主持收到匿名听众的连载来信，信中故事竟与一桩悬案惊人吻合。声音穿过城市的夜，也牵出她一直回避的过去。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20poster%20art%2C%20vintage%20radio%20microphone%20glowing%20in%20a%20dim%20studio%20at%20night%2C%20deep%20navy%20blue%20with%20warm%20amber%20glow%2C%20mysterious%20intimate%20lighting%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20no%20text&width=500&height=750&seq=krfilm-p20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dim%20radio%20broadcast%20studio%20at%20night%20with%20glowing%20controls%20and%20soundproof%20walls%2C%20deep%20navy%20blue%20and%20warm%20amber%20grading%2C%20mysterious%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-b20&orientation=landscape",
    featured: false,
  },
];